import {combineLatest, Subscription} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {AuthState} from '../../../auth/states/auth/auth.state';
import {PermissionsService} from '../../../permissions/permissions.service';

@Component({
  selector: 'app-dashboard-redirect',
  templateUrl: './dashboard-redirect.component.html',
  styleUrls: ['./dashboard-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardRedirectComponent implements OnInit, OnDestroy {
  public readonly isInitialized$ = this.store.select(AuthState.isInitialized);
  public readonly currentUser$ = this.store.select(AuthState.getUser);

  /** Contain component subscriptions. Will be unsubscribed on destroy. */
  private readonly subscription = new Subscription();

  constructor(private store: Store, private router: Router, private route: ActivatedRoute, public userCan: PermissionsService) {}

  ngOnInit(): void {
    // Todo: uncomment when isn't used as prototype anymore.
    // Define the user's permissions and redirect accordingly.
    this.subscription.add(
      combineLatest([this.currentUser$, this.isInitialized$])
        .pipe(
          // Wait until the user is loaded.
          filter(([user, isInitialized]) => isInitialized && !!user),

          // Filter out the user.
          map(([user]) => user),

          // Take the first emitted value.
          take(1)
        )
        .subscribe(user => {
          // Imaging center dashboard.
          if (this.userCan.uploadAsImagingCenter) {
            this.router.navigate(['imaging-center'], {relativeTo: this.route});

            // Clinic dashboard.
          } else if (this.userCan.accessSharedAccounts) {
            this.router.navigate(['clinic-patients'], {relativeTo: this.route});

            // Single study viewer dashboard.
          } else {
            this.router.navigate(['user', user.uid, 'study'], {relativeTo: this.route});
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
